import { isComposeStoreAvailable, getOpenedForm } from 'owa-calendar-compose-store-manager';
import { QUICK_COMPOSE_FORM_TYPE } from 'owa-calendar-helpers-types/lib/ComposeTypes';

/**
 * Checks if QuickCompose form is open
 */
export default function isQuickComposeOpen(formId: string): boolean {
    return isComposeStoreAvailable(formId) && getOpenedForm(formId) == QUICK_COMPOSE_FORM_TYPE;
}
